<template>
  <div class="section-dark resume" id="resume">
    <div class="container">
      <div class="columns is-multiline" data-aos="fade-in" data-aos-easing="linear">
        <div class="column is-12 about-me">
          <h1 class="title has-text-centered section-title">
            {{ $t('message.resume.head') }}
          </h1>
        </div>
        <div class="column is-12">
          <div class="timeline" v-if="$t('message.resume.stations').length > 0">
            <div class="timeline-container" v-for="(station, index) in $t('message.resume.stations')" :key="index">
              <div class="content">
                <h2>{{ station.head }}</h2>
                <div v-html="station.content" />
               </div>
            </div>
          </div>
        </div>
        <div class="column is-10 has-text-centered is-offset-1">
          <h2 class="subtitle" v-html="$t('message.resume.footerText')" />
          <!-- <form action="example.docs">
            <button class="button">
              Download Resume&emsp;<i class="fad fa-download fa-lg"></i>
            </button>
          </form> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Resume'
}
</script>

<style scoped>

/* The actual timeline (the vertical ruler) */
.timeline {
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
}

.timeline h2 {
  font-size: medium
}

/* The actual timeline (the vertical ruler) */
.timeline::after {
  content: '';
  position: absolute;
  width: 6px;
  background-color: white;
  top: 0;
  bottom: 0;
  left: 50%;
  margin-left: -3px;
}

/* Container around content */
.timeline-container {
  padding: 10px 40px;
  position: relative;
  background-color: inherit;
  width: 50%;
}

/* The circles on the timeline */
.timeline-container::after {
  content: '';
  position: absolute;
  width: 25px;
  height: 25px;
  right: -13px;
  background-color: white;
  border: 4px solid #FF9F55;
  top: 17px;
  border-radius: 50%;
  z-index: 1;
}

/* Place the container to the left */
.timeline-container:nth-child(odd) {
  left: 0;
}

/* Place the container to the right */
.timeline-container:nth-child(even) {
  left: 50%;
}

/* Add arrows to the left container (pointing right) */
.timeline-container:nth-child(odd)::before {
  content: " ";
  height: 0;
  position: absolute;
  top: 20px;
  width: 0;
  z-index: 1;
  right: 30px;
  border: medium solid white;
  border-width: 10px 0 10px 10px;
  border-color: transparent transparent transparent white;
}

/* Add arrows to the right container (pointing left) */
.timeline-container:nth-child(even)::before {
  content: " ";
  height: 0;
  position: absolute;
  top: 22px;
  width: 0;
  z-index: 1;
  left: 30px;
  border: medium solid white;
  border-width: 10px 10px 10px 0;
  border-color: transparent white transparent transparent;
}

/* Fix the circle for containers on the right side */
.timeline-container:nth-child(even)::after {
  left: -12px;
}

/* The actual content */
.content {
  padding: 20px 30px;
  background-color: white;
  position: relative;
  border-radius: 6px;
}

/* Media queries - Responsive timeline on screens less than 600px wide */
@media screen and (max-width: 600px) {
/* Place the timelime to the left */
  .timeline::after {
    left: 31px;
  }

/* Full-width containers */
  .timeline-container {
    width: 100%;
    padding-left: 70px;
    padding-right: 25px;
  }

/* Make sure that all arrows are pointing leftwards */
  .timeline-container::before {
    left: 60px;
    border: medium solid white;
    border-width: 10px 10px 10px 0;
    border-color: transparent white transparent transparent;
  }

/* Make sure all circles are at the same spot */
  .timeline-container:nth-child(odd)::after, .timeline-container:nth-child(even)::after {
    left: 19px;
  }

/* Make all right containers behave like the left ones */
  .timeline-container:nth-child(even) {
    left: 0%;
  }

  .timeline-container:nth-child(even)::before {
    left: 60px;
  }

  .timeline-container:nth-child(odd)::before {
    border: medium solid white;
    border-width: 10px 10px 10px 0;
    border-color: transparent white transparent transparent;
  }
}
</style>
